import { Component } from '@angular/core';

@Component({
    selector: 'dd-app-loading',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent {

  constructor() { }
}
